import { useQuery } from '@tanstack/react-query';

import { listOrganizations } from '../services/api';
import { organizationKeys } from '../services/queryKeys';

export function useOrganizations() {
    return useQuery({
        queryKey: organizationKeys.list(),
        queryFn: listOrganizations
    });
}
